module.exports = __webpack_public_path__ + "img/shenqing.e0e6a44e.png";